/* Merge an AI extraction into an existing job card without clobbering what the user typed. */
const norm = (s) => (s || "").toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, " ").split(/\s+/).filter(Boolean);
const similar = (a, b) => {
  const A = new Set(norm(a)), B = new Set(norm(b));
  if (!A.size || !B.size) return a.trim().toLowerCase() === b.trim().toLowerCase();
  let inter = 0; A.forEach((t) => { if (B.has(t)) inter++; });
  return inter / Math.min(A.size, B.size) >= 0.85;  // token-set similarity on the shorter item
};
export const isDuplicate = (item, list) => list.some((x) => similar(x, item));

export const EMPTY_EDITED = { title: false, tasks: false, hazards: false, access_notes: false };

/** @returns {{card, added:{tasks:number,hazards:number}}} */
export const mergeExtraction = (card, ai, edited = EMPTY_EDITED, { withAudio = false } = {}) => {
  const c = card || {};
  const tasks = [...(c.tasks || [])];
  let addedTasks = 0;
  (ai.tasks || []).forEach((t) => { if (t && !isDuplicate(t, tasks)) { tasks.push(t); addedTasks++; } });
  const hazards = [...(c.hazards || [])];
  let addedHazards = 0;
  (ai.hazards || []).forEach((h) => { if (h && !isDuplicate(h, hazards)) { hazards.push(h); addedHazards++; } });
  const next = {
    ...c,
    title: edited.title && (c.title || "").trim() ? c.title : (ai.title || c.title || ""),
    tasks, hazards,
    transcript: withAudio || !c.transcript ? (ai.transcript ?? c.transcript ?? "") : c.transcript,
    language: withAudio || !c.language ? (ai.language ?? c.language) : c.language,
    provisional: false,
  };
  return { card: next, added: { tasks: addedTasks, hazards: addedHazards } };
};

export const summarizeMerge = ({ tasks, hazards }) => {
  const parts = [];
  if (tasks) parts.push(`${tasks} task${tasks === 1 ? "" : "s"}`);
  if (hazards) parts.push(`${hazards} hazard${hazards === 1 ? "" : "s"}`);
  return parts.length ? `Added ${parts.join(", ")}` : "No new items found";
};
